module.exports = __webpack_public_path__ + "static/media/fs80.59ded122.jpg";